export const environment = {
    URL_BACKEND: 'https://sipe.info/st',
    URL_SERVICIOS: 'https://sipe.info/api',
    URL_FRONTEND: 'https://sipe.info/'
    // URL_BACKEND: 'http://localhost:8000',
    // URL_SERVICIOS: 'http://localhost:8000/api',
    // URL_FRONTEND: 'http://localhost:4200/'
};
